"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var owa_mail_opt_out_view_1 = require("owa-mail-opt-out-view");
var mailOptinUtility_1 = require("owa-mail-optin/lib/utils/mailOptinUtility");
var setClientOptedIn_1 = require("owa-mail-store/lib/actions/setClientOptedIn");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('clientOptOut', datapoints_1.default.optOutDatapoint)(function clientOptOut(modulePath) {
    setClientOptedIn_1.default(false);
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('usv-forum') && isUserInSample()) {
        owa_mail_opt_out_view_1.lazyShowOptOutDialog.importAndExecute(modulePath);
    }
    else {
        mailOptinUtility_1.optIntoJsmvvmClientAndRedirect(modulePath);
    }
});
function isUserInSample() {
    var upn = getUserConfiguration_1.default().SessionSettings.UserPrincipalName;
    var day = new Date().toDateString();
    var hash = djb2a(day + upn);
    return hash % 10 === 0;
}
function djb2a(key) {
    var hash = 5381;
    for (var i = 0; i < key.length; i++) {
        hash = (hash * 33) ^ key.charCodeAt(i);
    }
    return hash >>> 0;
}
//# sourceMappingURL=clientOptOut.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/clientOptOut.js
// module id = 5635
// module chunks = 62